// extracted by mini-css-extract-plugin
module.exports = {"root":"NotFound_root__qSQVy"};